import { State } from '../../reducers/rootReducer'
import { DisplayMode } from '../../../entities/CarlineGroup'

const carlineGroupsDisplayModeSelector = (state: State): DisplayMode => (
    state.carlineSelection.displayMode
)

export default carlineGroupsDisplayModeSelector
